<ng-container *transloco="let t">
    <ng-container *ngIf="view === RequestsPageComponentView.LIST">
        <router-outlet></router-outlet>
    </ng-container>
    <ng-container *ngIf="view === RequestsPageComponentView.TAB">
        <app-nav-tabs [reduceHorizontalSpacing]=true [useRouterOutlet]="true">
            <app-nav-tab [title]="t('request.tab.incoming')" [itemId]="1" [route]="INCOMING_REQUESTS">
            </app-nav-tab>
            <app-nav-tab [title]="t('request.tab.outgoing')" [itemId]="2" [route]="OUTGOING_REQUESTS">
            </app-nav-tab>
        </app-nav-tabs>
    </ng-container>
</ng-container>
